export default "__VITE_ASSET__365aa934__"